import React, { useContext } from "react";
import { Container, Navbar, Nav, ButtonGroup, Button, NavDropdown} from "react-bootstrap";
import './index.scss';
import logo from "../../assets/logo.png";
import { useNavigate } from "react-router-dom";
import { UserContext } from '../../context/UserContext';
import { FaCar } from "react-icons/fa";
import { GiMechanicGarage } from "react-icons/gi";
import { GiCarWheel } from "react-icons/gi";
import { TbSteeringWheel } from "react-icons/tb";
const Navigation = () => {
    const {user} = useContext(UserContext)
    const navigate = useNavigate();      
    const entrada = () => {   
        if(user.islogin){
            navigate('/entrada')
             
        }    
    }    
    const home = () => {
        if(user.islogin){
            navigate('/Home')
             
        }    
    }  
    const clientes = () => {
        if(user.islogin){
            navigate('/Clientes')
        }    
    }   
    const veiculo = () => {
        if(user.islogin){
            navigate('/Veiculo')
             
        }    
    }  
    const configuracoes = (n: number) => {
        if(user.islogin){
            if (n === 1 ){
                navigate('/Retorno')
            }
             
        }    
    }   
    const oficina = () => {
        if(user.islogin){
            navigate('/Oficina')
             
        }    
    }  
    const balanceamento = () => {
        if(user.islogin){
            navigate('/balanceamento')
             
        }    
    }   
    const alinhamento = () => {
        if(user.islogin){
            navigate('/alinhamento')
             
        }    
    }  
    const monitordesconto = () => {
        if(user.islogin){
                navigate('/Aprovacaodesconto')        
        }    
    } 
    const Imprimir = () => {
        if(user.islogin){
                navigate('/Printer')        
        }    
    }  
    const Extrato = () => {
        if(user.islogin){
                navigate('/Extrato')        
        }    
    }                              
    return (
        <>
            <div>
                <Navbar variant="" expand="lg">
                    <Container className="fw-semibold text-white">
                        <Navbar.Brand onClick={() => home()}>
                        <img
                            src={logo}
                            width="60"
                            height="30"
                            className="d-inline-block align-top"
                            alt="Car Center Pneus Brasil"
                        />            
                        </Navbar.Brand>
                        <Navbar.Toggle aria-controls="basic-navbar-nav" />
                        <Navbar.Collapse id="basic-navbar-nav">
                        <Nav className="me-auto">
                            {(user.tipo ==='0' || user.tipo ==='2') ?
                               ( <abbr title='Iniciar entrada do veiculo' className="mt-2 me-2">
                                    <button onClick={() => entrada()} className="btn btn-outline-dark"><FaCar size={30}/></button>
                                </abbr>):('')
                            
                            }
                            {(user.tipo === '0' || user.tipo === '4') ?
                                (<abbr title='Mecanica' className="mt-2 me-2">
                                    <button onClick={() => oficina()} className="btn btn-outline-dark"><GiMechanicGarage  size={30}/></button>
                                </abbr>):('') 
                            }  
                            {(user.tipo === '0' || user.tipo === '4')  ?   
                                (<abbr title='Balanceamento' className="mt-2 me-2">
                                    <button onClick={() => balanceamento()} className="btn btn-outline-dark"><GiCarWheel  size={30}/></button>
                                </abbr>):('') 
                            } 
                            {(user.tipo === '0' || user.tipo === '4')  ?   
                                (<abbr title='Alinhamento' className="mt-2 me-2">
                                    <button onClick={() => alinhamento()} className="btn btn-outline-dark"><TbSteeringWheel   size={30}/></button>
                                </abbr>):('')
                            }                                                                                       
                        </Nav>
                        <Nav className="d-flex flex-row-reverse bd-highlight">    
                            <ButtonGroup aria-label="Basic example" >
                                <Button variant="">
                                    <>                                    
                                        {(user.tipo === '0' || user.tipo === '2')  ? 
                                        
                                        ( 
                                            <NavDropdown title="Acessos">
                                            <NavDropdown.Item onClick={() => clientes()}>Clientes</NavDropdown.Item>
                                            <NavDropdown.Item onClick={() => veiculo()}>Veiculos</NavDropdown.Item>
                                            <NavDropdown.Item onClick={() => configuracoes(1)}>Reativar OS</NavDropdown.Item> 
                                            <NavDropdown.Item onClick={() => Imprimir()}>Imprimir Orçamento</NavDropdown.Item> 
                                            <NavDropdown.Item onClick={() => Extrato()}>Extrato do Cliente</NavDropdown.Item>
                                            {(user.tipo === '0' )  ? 
                                                (<NavDropdown.Item onClick={() => monitordesconto()}>Monitor de Descontos</NavDropdown.Item>):
                                                ('')
                                            }    
                                            <NavDropdown.Item href="/">Sair</NavDropdown.Item> 
                                            </NavDropdown>
                                        ): 
                                        (
                                            <>
                                            {(user.tipo === '6')  ?                                        
                                                ( 
                                                    <NavDropdown title="Acessos">
                                                        <NavDropdown.Item onClick={() => monitordesconto()}>Monitor de Descontos</NavDropdown.Item>
                                                        <NavDropdown.Item href="/">Sair</NavDropdown.Item>
                                                    </NavDropdown>
                                                ): 
                                                (
                                                    <NavDropdown.Item href="/">Sair</NavDropdown.Item>
                                                )
                                            }                                            
                                            </>

                                        )
                                        }    
                                    </>
                                </Button>
                            </ButtonGroup>
                        </Nav>    
                        </Navbar.Collapse>
                        
                    </Container>
                </Navbar>    
            </div>
        </>
    ) 
}

export default Navigation;